import * as types from '../mutation-types';
const state = () => ({
	configs: {},
	default_financial_file_accounts: {},
	system_paths: {}
})

const actions = {
	fetchAll({ commit }) {
		return window.axios.get('Configurations').then(response => {
            commit(types.STORE_CONFIGS, response.data)
            return response.data;
		})
	},
	fetchDefaultFinancialFileAccounts({ commit }) { 
		return window.axios.get('Configurations/FinancialFileAccounts').then(response => {
			commit(types.STORE_DEFAULT_FINANCIAL_FILE_ACCOUNTS, response.data)
		});
	},
	changeDefaultFinancialFileAccounts({ commit }, {accountConfigType, accountId}) { 
		return window.axios.put(`Configurations/FinancialFileAccounts/${accountConfigType}/${accountId}`).then(() => {
			commit('', '')
		});
	},
	removeDefaultFinancialFileAccounts(vuexContext, { type }) { 
		return window.axios.delete(`Configurations/FinancialFileAccounts/${type}/Remove`)
	},
	fetchSystemPaths({ commit }) { 
		return window.axios.get('SystemInfo/FilePathes').then(response => {
			commit(types.STORE_SYSTEM_PATHS, response.data)
		});
	},
	invalidateCache(){
		return window.axios.post('Configurations/InvalidateCache');
	},
	createBackup() {
		return window.axios.get('Configurations/Backup', { responseType: 'blob' })
		.then((response) => {
			return response.data;
		});
	}
}
const getters = {
	getAccountById: state => id => state.configs.accounts.find(t => t.id === id),
	getCurrencyById: state => id => state.configs.currencies.find(c => c.id === id)
};
const mutations = {
    [types.STORE_CONFIGS](state, configs) {
		state.configs = configs;
	},
	[types.STORE_DEFAULT_FINANCIAL_FILE_ACCOUNTS](state, accounts) {
        state.default_financial_file_accounts = accounts;
	},
	[types.STORE_SYSTEM_PATHS](state, paths) {
        state.system_paths = paths;
	},
};

export default {
	namespaced: true,
	state,
	mutations,
	actions,
	getters
};

